import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { trackingReducer } from './components/tracking/reducer';
import { errorReducer } from './components/common/errorReducer';
import { successReducer } from './components/common/successReducer';

const rootReducer = combineReducers({
    tracking: trackingReducer,
    error: errorReducer,
    success: successReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export function configureStore() {
    const middlewares = [thunkMiddleware];
    const middleWareEnhancer = applyMiddleware(...middlewares);

    const store = createStore(rootReducer, composeWithDevTools(middleWareEnhancer));

    return store;
}
